export default "__VITE_ASSET__BlUOKMLI__"